import { Injectable, LOCALE_ID } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { icons } from '../icons';

@Injectable({
    providedIn: 'root',
})
export class IconService {
    constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    ) { }

    private getSecureIconPath(url: string): SafeResourceUrl {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }

    public registerIcons(): void {
        icons.forEach((icon) => {
            {
                this.matIconRegistry.addSvgIconLiteral(
                    icon.name,
                    this.domSanitizer.bypassSecurityTrustHtml(icon.svg || '')
                );
            }
        });
    }
}